import { action } from 'sky-engine/api/index'

import { BATCH_MAINTENANCE, COMMON_MNG, SYSTEM_INFO, PERMISSION } from '@/api/apiModules'
/**
 * 获取存储策略枚举类型
 * @param {*} data
 * @returns
 */
export function getBackupType() {
  return action('global/enum', 'backupType', {})
}

/**
 * 获取计算器场景枚举值
 * @param {*} data
 * @returns
 */
export function getCalculatorScene() {
  return action('global/enum', 'calculatorScene', {})
}

export function getProjectType() {
  return action('global/enum', 'projectType')
}

export function getArea() {
  return action('global/enum', 'area')
}

/**
 * 获取桌面模式枚举值
 * @param {*} data
 * @returns
 */
export function getDesktopType() {
  return action(COMMON_MNG, 'desktopType', {})
}

/**
 * 获取网络速度枚举值
 * @param {*} data
 * @returns
 */
export function getNetworkSpeed() {
  return action('global/enum', 'networkSpeed', {})
}

/**
 * 获取网络速度枚举值
 * @param {*} data
 * @returns
 */
export function getIndustryList() {
  return action('projectInfo/industry', 'list', { unPage: true })
}

/**
 * 获取系统维护状态
 * @param {*} data
 * @returns
 */
export function getSystemSpecEditState() {
  return action('system/spec/edit', 'state', { unPage: true })
}

/**
 * 保存系统维护状态
 * @param {*} data
 * @returns
 */
export function saveSystemSpecEditState(data) {
  return action('/system/spec/edit', 'switch', data)
}

/**
 * 获取系统维护状态
 * @param {*} data
 * @returns
 */
export function sendVerifyCodeOnPhone(data) {
  return action('/base/admin', 'sendVerifyCodeOnPhone', data)
}

/**
 * 获取系统维护状态
 * @param {*} data
 * @returns
 */
export function registerOrLoginOnPhone(data) {
  return action('/base/admin', 'registerOrLoginOnPhone', data)
}

/**
 * 获取系统维护状态
 * @param {*} data
 * @returns
 */
export function verifyPhoneCode(data) {
  return action('/base/admin', 'verifyPhoneCode', data)
}

/**
 * 获取系统维护状态
 * @param {*} data
 * @returns
 */
export function registerUser(data) {
  return action('/base/admin', 'registerUser', data)
}

/**
 * 导出规格数据
 * @param {*} data
 * @returns
 */
export function exportSpecData(data) {
  return action(BATCH_MAINTENANCE, 'exportData', data)
}

/**
 * 导入规格数据
 * @param {*} data
 * @returns
 */
export function importSpecData(data) {
  return action(BATCH_MAINTENANCE, 'importData', data)
}

/**
 * 查询状态
 * @param {*} data
 * @returns
 */
export function getMaintenanceStatus(data) {
  return action(BATCH_MAINTENANCE, 'getStatus', data)
}

/**
 * 更新账户可用状态
 * @param {*} data
 * @returns
 */
export function SettingEnableStatus(data) {
  return action('/base/admin', 'setting/enableStatus', data)
}

/**
 * 创建查询记录
 * @param {*} data
 * @returns
 */
export function createQueryCrmOrderInfo(data) {
  return action(SYSTEM_INFO, 'crmOrder/create', data)
}

/**
 * 查询记录
 * @param {*} data
 * @returns
 */
export function getCrmOrderDetail(data) {
  return action(SYSTEM_INFO, 'crmOrder/detail', data)
}

/**
 * crm信息查询
 * @param {*} data
 * @returns
 */
export function queryCrmOrderInfo(data) {
  return action(SYSTEM_INFO, 'crmOrder/query/detail', data)
}

/**
 * 获取飞书文档，内嵌的签名
 * @param {*} data
 * @returns
 */
export function getFeiShuDocumentSignature(data) {
  return action(PERMISSION, 'feiShu/document/signature', data)
}

/**
 * 获取飞书电子表格，内嵌的签名
 * @param {*} data
 * @returns
 */
export function getFeiShuSheetSignature(data) {
  return action(PERMISSION, 'feiShu/sheet/signature', data)
}

/**
 * 申请资源计算器电子表格访问权限-企业
 * @param {*} data
 * @returns
 */
export function applyFeiShuSheetEnt(data) {
  return action(PERMISSION, 'feiShu/sheet/ent/prepare', data)
}

/**
 * 申请资源计算器电子表格访问权限-教育
 * @param {*} data
 * @returns
 */
export function applyFeiShuSheetEdu(data) {
  return action(PERMISSION, 'feiShu/sheet/edu/prepare', data)
}

/**
 * 取飞书权限信息
 * @param {*} data
 * @returns
 */
export function getFeiShuUrlAuth(data) {
  return action(PERMISSION, 'feiShu/auth', data)
}

/**
 * 获取角色列表
 * @param {*} data
 * @returns
 */
export function getRoleList(data) {
  return action('role', '/base/list', data)
}
